<template>
    <ul class="list-group list-group-flush">
        <li class="list-group-item">
            <div class="row">
                <div class="col-12 col-lg-4 pb-1">
                    <label for="district">Ort:</label>
                    <Select2
                        :options="district_select"
                        v-model="selected_district"
                        class="w-100"
                        id="district"></Select2>
                </div>
                <div v-if="streets.length > 1" class="col-12 col-lg-4 pb-1">
                    <label for="street">Straße:</label>
                    <Select2
                        :options="streets_select"
                        v-model="selected_street"
                        id="street"
                        class="w-100"></Select2>
                </div>
            </div>
            <div class="row">
                <div class="col-12 pt-2 mb-4">
                    <div class="btn-calender-group">
                        <button
                            v-for="category in categoriesBase"
                            :key="category.title"
                            v-on:click="selectCategory(category)"
                            :class="{'btn-secondary': selected_categories.find(x => x.id === category.id)}"
                            class="btn btn-category btn-primary mb-1">
                            <img v-if="category.icon_url" style="height: 25px; object-fit: contain" :src="category.icon_url" class="icon" />
                            {{category.title}}
                        </button>
                    </div>
                    <div class="d-flex flex-column flex-md-row" style="justify-content: space-between;">
                        <a
                            href="#"
                            v-on:click="selectCategory(null)"
                            :class="{ 'btn-secondary': selected_categories.length === 0}"
                            class="btn btn-primary mb-1 mb-md-0 mr-md-2"
                            style="white-space: nowrap"
                            >Alle anzeigen</a
                        >
                        <div class="text-md-right align-self-center w-100 w-md-auto">
                            <div v-if="requestEvents" class="d-flex flex-column flex-md-row btn-group-responsive w-100 justify-content-end" role="group" aria-label="Aktionen" id="action-buttons">
                                <template v-for="downloadLink in downloadLinks">
                                    <a
                                        :key="downloadLink.url"
                                        class="btn btn-primary btn-sm download-url mb-1 mb-md-0 mr-md-1"
                                        :id="'download-'+downloadLink.name.toLowerCase()"
                                        target="_blank"
                                        :href="downloadLink.url"
                                        :download="downloadLink.name == 'Jahresübersicht als PDF' ? '' : 'touren.ics'">
                                        <i class="fal fa-download fa-fw"></i>{{downloadLink.name}}
                                    </a>
                                </template>
                                <button
                                    @click="toggleReminderSignUp"
                                    class="btn btn-primary btn-sm mb-1 mb-md-0"
                                    :class="{ 'btn-secondary': showReminderSignUp }"
                                >
                                    <i class="fal fa-envelope fa-fw"></i>
                                    Erinnerungen per E-Mail
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </li>
        <li class="list-group-item" v-if="showReminderSignUp">
            <div class="row">
                <EmailReminderForm
                    class="col-12 pt-2 mb-4"
                    :street="street"
                    :district="district"
                    :city="city"
                    :categories="selected_categories.flatMap(x => x.slug)"
                />
            </div>
        </li>
        <li v-if="extraHeaderContent" class="list-group-item calendar-header py-4">
            <div v-html="extraHeaderContent"></div>
        </li>
        <li class="list-group-item">
            <FullCalendar
                ref="fullCalendar"
                :locale="calendarLocale"
                :eventRender="event_render"
                defaultView="dayGridMonth"
                :plugins="calendarPlugins"
                :events="fetch_events"
                :header="header"
                :dates-render="viewChanged"
                :displayEventTime="false"
                :week-numbers="true"
                :week-numbers-within-days="true"
            />
        </li>
        <li v-if="extraFooterContent" class="list-group-item calendar-footer py-4">
            <div v-html="extraFooterContent"></div>
        </li>
    </ul>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import listPlugin from '@fullcalendar/list';
import deLocale from '@fullcalendar/core/locales/de';
import Select2 from 'v-select2-component';
import EmailReminderForm from "./EmailReminderForm.vue";
import 'axios';

export default {
    components: {
        FullCalendar,
        Select2
    },
    props: {
        tourFetchUrl: String,
        citiesBase: Array,
        categoriesBase: Array,
        extraHeaderContent: String,
        extraFooterContent: String
    },
    data() {
        return {
            view: "month",
            selected_period: 0,
            selected_district: 0,
            selected_street: 0,
            selected_categories: [],
            header: this.getHeader(),
            calendarPlugins: [dayGridPlugin, listPlugin],
            calendarLocale: deLocale,
            showReminderSignUp: false,
            isMobile: window.innerWidth < 768
        };
    },
    mounted() {
        this.calendarLocale.days_short = {
            0: 'So',
            1: 'Mo',
            2: 'Di',
            3: 'Mi',
            4: 'Do',
            5: 'Fr',
            6: 'Sa',
        };

        if (this.isMobile) {
            this.$refs.fullCalendar.getApi().changeView('listYear');
        }

        this.viewChanged();
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    computed: {
        cities() {
            return this.citiesBase;
        },
        city() {
            return this.cities.find(city => city.id === parseInt(this.district.city_id));
        },
        districts() {
            return _.concat(_.flatten(_.map(this.cities, "districts")), [{ name: "-- Ort auswählen --", id: 0 }]);
        },
        district() {
            return this.districts.find(district => district.id === parseInt(this.selected_district));
        },
        district_select() {
            return _.sortBy(
                this.districts.map(district => {
                    let city = this.cities.find(city => city.id === district.city_id);
                    let text = district.name;
                    if (city && city.name !== district.name) text = city.name + " OT " + text;

                    return { text: text, id: district.id };
                }),
                "text"
            );
        },
        is_district_selected() {
            return this.selected_district && this.selected_district != 0;
        },
        streets() {
            let defaultEntry = {name: '-- Straße auswählen --', id: 0};
            if (!this.is_district_selected) return [defaultEntry];
            return _.concat(this.district.streets,  [defaultEntry]);
        },
        street() {
            let id = this.district?.streets?.find(street => street.id === parseInt(this.selected_street));

            return id ? {id: id.id, name: id.name} : null;
        },
        streets_select() {
            return _.sortBy(
                this.streets.map(street => {
                    return { text: street.name, id: street.id };
                }),
                "text"
            );
        },
        is_street_selected() {
            return this.selected_street && this.selected_street != 0;
        },
        downloadLinks() {
            return [
                {name: 'Jahresübersicht als PDF', url: this.getDownloadLink('pdf')},
                {name: 'Kalenderimport', url: this.getDownloadLink('ical')},
                // {name: 'ICS', url: this.getDownloadLink('ics')},
            ];
        },
        requestEvents() {
            if (!this.is_district_selected) {
                return false;
            }

            let canSelectStreet = this.district?.streets?.length;

            if (canSelectStreet && !this.is_street_selected) {
                return false;
            }

            return true;
        }
    },
    watch: {
        requestEvents() {
            this.$refs.fullCalendar.getApi().refetchEvents();
        },
        selected_street() {
            this.$refs.fullCalendar.getApi().refetchEvents();
        },
        selected_district() {
            this.selected_street = 0;
            this.$refs.fullCalendar.getApi().refetchEvents();

            if (this.district?.streets?.length == 1) {
                this.selected_street = this.district.streets[0].id;
            }
        },
        selected_categories() {
            this.$refs.fullCalendar.getApi().refetchEvents();
        }
    },
    methods: {
        getHeader: function() {
            return {
                left: "prev,next today",
                center: "title",
                // right: 'dayGridMonth,dayGridWeek,listYear',
                right: "dayGridMonth,listYear"
            };
        },
        selectCategory(category) {
            if (category === null) return this.selected_categories = [];

            let index = this.selected_categories.findIndex(x => x.id === category.id);

            if (index === -1) {
                this.selected_categories.push(category);
            } else {
                this.selected_categories.splice(index, 1);
            }
        },
        getDownloadLink(type) {
            return '/download?system=' + type
                + '&period=' + this.selected_period
                + (!this.is_street_selected && this.is_district_selected ? '&district=' + this.selected_district : '')
                + (this.is_street_selected ? '&street=' + this.selected_street : '')
                + '&categories=' + _.map(this.selected_categories, 'id').toString()
                + '&view=' + this.view;
        },
        fetch_events(info, successCallback, failureCallback) {
            if (!this.requestEvents) {
                successCallback([]);
                return;
            }

            let start = info.startStr;
            let end = info.endStr;

            let url = new URL(this.tourFetchUrl);

            url.searchParams.append('include', 'dates,categories');

            url.searchParams.append('filter[has_date_between]', start + ',' + end);
            url.searchParams.append('filter[has_district_ids]', this.selected_district);

            if (this.is_street_selected) {
                url.searchParams.append('filter[has_street_ids_or_none]', this.selected_street);
            }

            if (this.selected_categories.length > 0) {
                url.searchParams.append(
                    'filter[has_category_ids]',
                    this.selected_categories.map((c) => c.id).join(',')
                );
            }

            axios.get(url).then((response) => {
                let tours = response.data.data;

                // events = selected categories x dates for every tour
                let events = tours.flatMap((tour) =>
                    tour.categories
                        .filter((category) =>
                            !this.selected_categories.length ||
                            this.selected_categories.find((sc) => sc.id == category.id))
                        .flatMap((category) =>
                            tour.dates.map((date) => {
                                let title = category.title

                                if (date.location) {
                                    title = title + "\n" + date.location
                                }

                                if (date.start_at && date.end_at) {
                                    let timeFormat = {hour: 'numeric', minute: 'numeric'};

                                    let startAt = new Date(date.start_at)
                                    title = title + "\n" + startAt.toLocaleTimeString('de', timeFormat);

                                    let endAt = new Date(date.end_at)
                                    title = title + " - " + endAt.toLocaleTimeString('de', timeFormat);
                                }

                                return {
                                    id: date.id,
                                    start: date.start_at,
                                    end: date.end_at || date.start_at,
                                    title: title,
                                    slug: category.slug,
                                };
                            })));

                successCallback(events);
            }).catch(failureCallback);
        },
        event_render(e) {
            let $el = $(e.el);

            if ($el.hasClass("fc-day-grid-event")) {
                $el.addClass("category-" + e.event.extendedProps.slug);
                $el.first(".fc-title-wrap").prepend(
                    "<i class='calendar-icon day-grid-icon icon-" + e.event.extendedProps.slug + "'></i>"
                );

                this.view = e.view.viewSpec.durationUnit;
            }
            if ($el.hasClass("fc-list-item")) {
                let $el = $(e.el);
                $el.children(".fc-list-item-marker").remove();
                let $content = $el.children(".fc-list-item-title");
                let content = $content.html();
                $content
                    .attr("colspan", 3)
                    .html("<i class='calendar-icon icon-" + e.event.extendedProps.slug + "'></i>" + content);

                this.view = e.view.viewSpec.durationUnit;
            }
        },
        viewChanged() {
            if (!this.$refs.fullCalendar) return 0;

            let currentYear = new Date().getFullYear();
            let selectedYear = this.$refs.fullCalendar
                .getApi()
                .getDate()
                .getFullYear();
            let selectedMonth = this.$refs.fullCalendar
                .getApi()
                .getDate()
                .getMonth();

            if (currentYear === selectedYear) {
                if (selectedMonth > 6) this.selected_period = 2;
                else this.selected_period = 1;
            } else {
                this.selected_period = 3;
            }

            if (this.district_select?.filter(x => x.id !== 0).length === 1) {
                this.selected_district = this.district_select[1].id;
            }
        },
        toggleReminderSignUp() {
            this.showReminderSignUp = !this.showReminderSignUp;
        },
        handleResize() {
            this.isMobile = window.innerWidth < 768;
        }
    }
};
</script>
